import React , {useEffect}from 'react';
import axios from 'axios';
import GlobalStyles from '../styles/global';
import Routes from '../routes';
import { CombineProviders } from '../store';

import Notification from '../components/Notification';
import { useCallback } from 'react';


const App = () => {
  const fetchClientIp = useCallback(async()=> {
    try {
      if (!localStorage.getItem('userIp')) {
        const { data } = await axios.get('https://api.ipify.org?format=json');
        if (data?.ip) {
          localStorage.setItem('userIp', data.ip);
        }
      }
    } catch (err) {
      console.error('Erro ao buscar IP do usuário:', err);
    }
  },[])
  useEffect(() => {
		fetchClientIp();
	}, [fetchClientIp]);

	return (
		<CombineProviders>
			<GlobalStyles />
			<Routes />

			<Notification />
		</CombineProviders>
	);
};

export default App;
